export const environment = {
  production: true,
  buildId: '3744648632223291',
  configFile: 'config.json',
};
